/**
 * The glass surface: the translucent `--surface-glass` fill, its
 * `--surface-glass-border` edge and the blur behind it. Where backdrop-filter
 * is unsupported the translucent fill would show the page unblurred through
 * the surface, so it falls back to the opaque card colour. Every glass
 * surface imports it (`glass.test.ts` fails on a copy); pair it with
 * `border` for the edge to draw.
 */
export const glassSurfaceClassName =
	'bg-surface-glass border-surface-glass-border supports-[not(backdrop-filter:blur(0))]:bg-card backdrop-blur-xl'

/**
 * The glass control: a chip or badge floating over the page or an image. The
 * same recipe as `glassSurfaceClassName` on the lighter `--control-glass`
 * fill.
 */
export const glassControlClassName =
	'bg-control-glass border-surface-glass-border supports-[not(backdrop-filter:blur(0))]:bg-card backdrop-blur-xl'
